import { useEtlSourceCount } from '@/viewmodel/features/etlSource/hooks/useEtlSourceCount';
import { useCurrentProjectIdViewModel } from '@/viewmodel/features/project';

export function useSourceCountViewModel(): number | undefined {
  return useEtlSourceCount(useCurrentProjectIdViewModel());
}
